import { StaticImage } from 'gatsby-plugin-image';

const ValuePropImage = ({ images }: { images: { sm?: string; md?: string; lg?: string } }) => {
    return (
        <>
            {/* Static Image before we are able to process uploaded value prop image from the WP block */}
            <StaticImage
                src="./images/zero_value_prop.svg"
                placeholder="blurred"
                alt="Low cost for the coverage you need"
                title="Low cost for the coverage you need"
            />
        </>
    );
};

export default ValuePropImage;
